export default "__VITE_ASSET__D8Z0hhDo__"